module.exports = __webpack_public_path__ + "img/1585849726894293108.61fde6a1.jpg";